import React, { useState, useEffect, useRef } from 'react';
import {config} from "../../shared/config.js";
import * as util from '../../shared/commons.js';
import axios from "axios";
import 'primeicons/primeicons.css';
import { Col, Container, Row } from 'react-bootstrap';
import { Link, Navigate, useNavigate  } from 'react-router-dom';
import { Button } from 'primereact/button';
import ShowError from '../../shared/ShowError.jsx';
import Laoding from '../../shared/Laoding.jsx';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Dialog } from 'primereact/dialog';
import GeneralDialogFooter from '../../shared/GeneralDialogFooter.jsx';
import ShowConfirm from '../../shared/ShowConfirm.jsx';
import Table from 'react-bootstrap/Table';
import { RadioButton } from "primereact/radiobutton";
import { Checkbox } from 'primereact/checkbox';        
import { InputText } from 'primereact/inputtext';
import CityCombo from '../../combos/CityCombo.jsx';
import { FloatLabel } from 'primereact/floatlabel';
import FaDate from '../../shared/FaDate.jsx';
import { InputNumber } from 'primereact/inputnumber';
import UserTypeCombo from '../../combos/UserTypeCombo.jsx';
import * as XLSX from 'xlsx';

var editedModules = [];
var editedParameters = {};
export default function SalaryDailyAmountTable(props) {
    const navigate = useNavigate();
    const dt = useRef(null);
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [copyFormVisible, setCopyFormVisible] = useState(false);
    const [editFormVisible, setEditFormVisible] = useState(false);
    
    const [yearNo, setYearNo] = useState(0);
    const [fromYearNo, setFromYearNo] = useState(0);
    const [toYearNo, setToYearNo] = useState(0);
    const [parameters, setParameters] = useState([]);

    useEffect(() => {
        
    }, []);

    const loadItems = function(){
        setLoading(true);
        var params = {
            param1:String(yearNo),
            param2:"",
            param3:"",
            param4:"",
            param5:"",
        };
        var url = config.Server+`/salary/base-price-table/list/get`;
        console.log("params in show summary is>", params);
        console.log("url in show summary is>", url);
        
        axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                response = response.data;
                if(response.length == 0){
                    setParameters([]);
                    setErrorMessage("یافت نشد");
                    setErorVisible(true);
                }
                else{
                    var ps = [];
                    for(var i=0;i<20;i++){
                        ps.push({value:0, oldValue:0, jobGroupNo:i+1,});
                    }
                    for(var i=0;i<response.length;i++){
                        ps[response[i].jobGroupNo-1]["value"] = response[i].dailySalary;
                        ps[response[i].jobGroupNo-1]["oldValue"] = response[i].dailySalary;
                    }
                    setParameters(ps);
                    setEditFormVisible(true);
                }
                setLoading(false);
                
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                setLoading(false);
            }
        })
        .catch(error => {
        console.log("error is>", error)
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            setLoading(false);
        });

    }

    const onIntegerInputChanged = (value, ind) =>{
        value = value.value;
        var v = 0;
        if(isNaN(value)) v = 0;
        else if(value == null) v = 0;
        else if(value == "") v = 0;
        else v = parseInt(value);
        var set = [...parameters];
        set[ind].value = v;
        setParameters(set);
    }
    const onDecimalInputChanged = (value, ind) =>{        
        value = value.value;
        var v = 0;
        if(isNaN(value)) v = 0;
        else if(value == null) v = 0;
        else if(value == "") v = 0;
        else v = parseFloat(value);
        var set = [...parameters];
        set[ind].value = v;
        setParameters(set);
    }
    const saveItem = function(ind){
        if(parameters[ind].value == parameters[ind].oldValue) return;
        
        var url = config.Server + `/salary/base-price-table/daily/save`;
        var params = {
            login:util.getLoginDto(), 
            yearNo:yearNo,
            jobGroupNo:parameters[ind].jobGroupNo,
            amount:String(parameters[ind].value),
        };
        setSaving(true);
        axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            console.log("response is>", response)
            if(response.state === "ok"){
                var set = [...parameters];
                set[ind].oldValue = set[ind].value;
                setParameters(set);
                
                setSaving(false);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                setSaving(false);
            }
        })
        .catch(error => {
            console.log("error is>", error)
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            setSaving(false);
        });

    }
    const onYearNoChanged = function(e, ind){
        var val = 0;
        if(e.value){
            val = e.value;
        }
        if(ind == 0)setYearNo(val);
        else if(ind == 1)setFromYearNo(val);
        else if(ind == 2){
            setToYearNo(val);
            setYearNo(val);
        }
    }
    const copyData = function (){
        var url = config.Server + `/salary/data/copy`;
        var params = {
            login:util.getLoginDto(), 
            fromYearNo:fromYearNo,
            toYearNo:toYearNo,
            target:"SalaryBasePriceTable",
        };
        setSaving(true);
        axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            console.log("response is>", response)
            if(response.state === "ok"){
                setCopyFormVisible(false);
                loadItems();
                
                setSaving(false);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                setSaving(false);
            }
        })
        .catch(error => {
            console.log("error is>", error)
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            setSaving(false);
        });

    }

    return(
        <>
        {
        (copyFormVisible == true)?
        <>
            <Row style={{padding:"0px", margin:"20px 0px 0px 0px", position:"relative"}}>
                <Col className="d-flex justify-content-center align-items-center" style={{marginBottom:"150px"}}>
                    <Col md={3} style={{border:"1px solid #b0b0b0", padding:"10px", borderRadius:"10px", position:"relative"}}>
                        <table style={{width:"100%", minWidth:"250px", marginLeft:"auto", marginRight:"auto"}}>
                            <tbody>
                                <tr>
                                    <td style={{fontSize:"1em", textAlign:"right"}} colSpan={2}>
                                        <img src={require("../../lib/images/back.png")} alt='برگشت' onClick={()=>{setCopyFormVisible(false)}} style={{width:"48px", height:"32px", cursor:"pointer"}} />                                        
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{fontSize:"1.2em", textAlign:"center"}}>سال مبدإ و مقصد را مشخص نمائید</td>
                                </tr>
                                <tr><td>&nbsp;</td></tr>
                                <tr><td>&nbsp;</td></tr>
                                <tr>
                                    <td style={{fontSize:"1em", textAlign:"center", direction:"rtl"}}>
                                        <FloatLabel>
                                            <InputNumber value={fromYearNo} onChange={(e) => {onYearNoChanged(e, 1)}} onValueChange={(e) => {onYearNoChanged(e, 1)}} useGrouping={false} minFractionDigits={0} maxFractionDigits={0} style={{direction:"ltr", textAlign:"center"}} />
                                            <label htmlFor="fromYearNo">سال مبدإ</label>
                                        </FloatLabel>
                                    </td>
                                </tr>
                                <tr><td>&nbsp;</td></tr>
                                <tr><td>&nbsp;</td></tr>
                                <tr>
                                    <td style={{fontSize:"1em", textAlign:"center", direction:"rtl"}}>
                                        <FloatLabel>
                                            <InputNumber value={toYearNo} onChange={(e) => {onYearNoChanged(e, 2)}} onValueChange={(e) => {onYearNoChanged(e, 2)}} useGrouping={false} minFractionDigits={0} maxFractionDigits={0} style={{direction:"ltr", textAlign:"center"}} />
                                            <label htmlFor="toYearNo">سال مقصد</label>
                                        </FloatLabel>
                                    </td>
                                </tr>
                                <tr><td>&nbsp;</td></tr>
                                <tr>
                                    <td style={{fontSize:"1em", textAlign:"center", direction:"ltr"}}>
                                        <div className="flex justify-content-center" style={{ direction: "ltr" }}>
                                            <Button severity="success" onClick={()=>{copyData()}} style={{borderRadius:"5px"}} loading={loading} iconPos="right" icon="pi pi-check">&nbsp;&nbsp;کپی شوند&nbsp;&nbsp;</Button>
                                        </div>
                                    </td>
                                </tr>
                                <tr><td>&nbsp;</td></tr>
                            </tbody>
                        </table>
                    </Col>
                </Col>
            </Row>
        </>
        :
        (editFormVisible == false)?
        <>
            <Row style={{padding:"0px", margin:"20px 0px 0px 0px", position:"relative"}}>
                <Col className="d-flex justify-content-center align-items-center" style={{marginBottom:"150px"}}>
                    <Col md={3} style={{border:"1px solid #b0b0b0", padding:"10px", borderRadius:"10px", position:"relative"}}>
                        <table style={{width:"100%", minWidth:"250px", marginLeft:"auto", marginRight:"auto"}}>
                            <tbody>
                                <tr>
                                    <td style={{fontSize:"1.2em", textAlign:"center"}}>سال مالی را مشخص نمائید</td>
                                </tr>
                                <tr>
                                    <td style={{fontSize:"1em", textAlign:"center", direction:"rtl"}}>
                                        <InputNumber value={yearNo} onChange={(e) => {onYearNoChanged(e, 0)}} onValueChange={(e) => {onYearNoChanged(e, 0)}} useGrouping={false} minFractionDigits={0} maxFractionDigits={0} style={{direction:"ltr", textAlign:"center"}} />
                                    </td>
                                </tr>
                                <tr><td>&nbsp;</td></tr>
                                <tr>
                                    <td style={{fontSize:"1em", textAlign:"center", direction:"ltr"}}>
                                        <div className="flex justify-content-center" style={{ direction: "ltr" }}>
                                            <Button severity="success" onClick={()=>{loadItems()}} style={{borderRadius:"5px"}} loading={loading} iconPos="right" icon="pi pi-check">&nbsp;&nbsp;مشاهده پارامترها&nbsp;&nbsp;</Button>
                                        </div>
                                    </td>
                                </tr>
                                <tr><td>&nbsp;</td></tr>
                                <tr><td>&nbsp;</td></tr>
                                <tr>
                                    <td style={{fontSize:"1em", textAlign:"center", direction:"ltr"}}>
                                        <div className="flex justify-content-center" style={{ direction: "ltr" }}>
                                            <Button severity="info" onClick={()=>{setCopyFormVisible(true)}} style={{borderRadius:"5px"}} iconPos="right" icon="pi pi-copy">&nbsp;&nbsp;کپی داده ها&nbsp;&nbsp;</Button>
                                        </div>
                                    </td>
                                </tr>
                                <tr><td>&nbsp;</td></tr>
                            </tbody>
                        </table>
                    </Col>
                </Col>
            </Row>
        </>
        :
        <>
            <Row style={{padding:"0px", margin:"20px 0px 0px 0px", position:"relative"}}>
                <Col className="d-flex justify-content-center align-items-center" style={{marginBottom:"150px"}}>
                    <Col md={6} style={{border:"1px solid #b0b0b0", padding:"10px", borderRadius:"10px", position:"relative"}}>
                        
                        <table style={{width:"100%", minWidth:"250px", marginLeft:"auto", marginRight:"auto", marginTop:"20px"}}>
                            <tbody>
                                <tr>
                                    <td style={{fontSize:"1em", textAlign:"right"}} colSpan={2}>
                                        <img src={require("../../lib/images/back.png")} alt='برگشت' onClick={()=>{setEditFormVisible(false)}} style={{width:"48px", height:"32px", cursor:"pointer"}} />                                        
                                    </td>
                                </tr>
                                {
                                    parameters.map((p, pInd)=>{
                                        return(
                                            <>
                                                <tr>
                                                    <td style={{fontSize:"1em", textAlign:"left", direction:"rtl", padding:"3px"}}>
                                                        دستمزد روزانه گروه {p.jobGroupNo} :
                                                    </td>
                                                    <td style={{fontSize:"1em", textAlign:"right", direction:"rtl"}}>
                                                        <InputNumber value={p.value} onBlur={()=>saveItem(pInd)} onChange={(e) => {onIntegerInputChanged(e, pInd)}} useGrouping={true} minFractionDigits={0} maxFractionDigits={0} style={{direction:"ltr", textAlign:"center"}} />
                                                    </td>
                                                </tr>
                                            </>
                                        )
                                    })
                                }
                                <tr><td colSpan={2}>&nbsp;</td></tr>
                                <tr><td colSpan={2}>&nbsp;</td></tr>
                            </tbody>
                        </table>
                    </Col>
                </Col>
            </Row>
            
        </>
        }
        <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
        </>
    )
}